import { useEffect } from "react";
import { Route, RouteProps, Routes, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth-context";
import {
	centralBankRoutes,
	commonRoutes,
	integratorRoutes,
	privateRoutes,
} from "../../src/routes/routeConfig";
import { Loading } from "../components/Loading";
import { USER_ROLES } from "../lib/constants";

const mapRoute = (route: RouteProps, index: number) => (
	<Route key={index} {...route} />
);

interface IProps {
	userId: string;
	userRole: USER_ROLES;
}

/**
 * Routes only a logged in  user could visit.
 */
export const AuthenticatedRoutes = ({
	userRole,
}: IProps): JSX.Element => {
	const location = useLocation();
	const { appUser } = useAuth();
	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	if (userRole === USER_ROLES.CENTRAL_BANK) {
		return (
			<Routes>
				{centralBankRoutes.map((route, idx) => (
					<Route element={route.element} key={idx}>
						{privateRoutes({ appUser }).map(mapRoute)}
						{commonRoutes.map(mapRoute)}
					</Route>
				))}
			</Routes>
		);
	}
	if (userRole === USER_ROLES.INTEGRATOR) {
		return (
			<Routes>
				{integratorRoutes.map((route, idx) => (
					<Route element={route.element} key={idx}>
						{privateRoutes({ appUser }).map(mapRoute)}
						{commonRoutes.map(mapRoute)}
					</Route>
				))}
			</Routes>
		);
	}
	return <Loading />;
};
